

export default function CustomTitle({text,  small} : {text: string, small?: boolean}) {
    return(<>{small?<h2 className="text-lg p-5" >{text}</h2>:<h1 className="text-[24px] p-5">{text}</h1>}</>)
}